/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './dispute_ledger_common';
import '../../common/currency';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "WriteOffDisputedAmountRequest": {
                "fields": {
                  "context": {
                    "type": ".squareup.corporate_card.service.RequestContext",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transactionToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "disputedMoney": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "writeOffMoney": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "reference": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "WriteOffDisputedAmountResponse": {
                "fields": {
                  "result": {
                    "type": ".squareup.corporate_card.service.TransactionResult",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "writeOffEntryToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "clawbackEntryToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 5,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.WriteOffDisputedAmountRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.WriteOffDisputedAmountResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE WriteOffDisputedAmountRequest @ squareup/corporate_card/service/write_off_disputed_amount.proto at 11:1
 */
export const WriteOffDisputedAmountRequest = $root.lookupType('squareup.corporate_card.service.WriteOffDisputedAmountRequest');
fixType(WriteOffDisputedAmountRequest, {
  context: {
    notEmpty: true
  },
  transactionToken: {
    notEmpty: true
  },
  disputedMoney: {
    notEmpty: true
  },
  writeOffMoney: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(WriteOffDisputedAmountRequest);
/**
 * SOURCE WriteOffDisputedAmountResponse @ squareup/corporate_card/service/write_off_disputed_amount.proto at 38:1
 */
export const WriteOffDisputedAmountResponse = $root.lookupType('squareup.corporate_card.service.WriteOffDisputedAmountResponse');
fixType(WriteOffDisputedAmountResponse, {
  result: {
    required: true
  }
});
Builder.createAndAttachToType(WriteOffDisputedAmountResponse);